import {
  MessageSquare, Phone, Send, Cpu, PenLine, Search, Mail, BarChart3,
  Briefcase, Coins, LayoutGrid, Share2, Shield, Target, Sparkles,
  Globe, Smartphone, Map, Calendar, Languages,
} from "lucide-react";
import { SERVICES } from "@/constants/landing";

const ICON_MAP = {
  message: MessageSquare, phone: Phone, send: Send, cpu: Cpu, pen: PenLine,
  search: Search, mail: Mail, chart: BarChart3, briefcase: Briefcase, coin: Coins,
  grid: LayoutGrid, share: Share2, shield: Shield, target: Target, sparkle: Sparkles,
  globe: Globe, smartphone: Smartphone, map: Map, calendar: Calendar, languages: Languages,
};

export default function Services() {
  return (
    <section id="services" className="py-20 sm:py-28 relative" data-testid="services-section">
      <div className="yg-divider" />
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8 pt-14 sm:pt-20">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 sm:mb-14">
          <div className="max-w-[640px]">
            <span className="yg-eyebrow">// 21 AI services</span>
            <h2 className="yg-h2 text-[clamp(30px,4.6vw,52px)] mt-3 text-white">
              The full stack.
              <br />
              <span className="text-[var(--yg-violet-light)]">Nothing bolted on.</span>
            </h2>
          </div>
          <p className="text-[14.5px] text-[var(--yg-text-mute)] max-w-[380px]">
            Chat, voice, ads, sites, apps, itineraries, bookings, data + strategy — all in Hindi, English &amp; Marathi.
          </p>
        </div>

        {/* Mobile: horizontal scroll · Desktop: full grid */}
        <div className="lg:hidden relative -mx-5">
          <div className="flex gap-3 overflow-x-auto no-scrollbar snap-x snap-mandatory px-5 pb-3" data-testid="services-scroll-mobile">
            {SERVICES.map((s, i) => {
              const Icon = ICON_MAP[s.icon] || Sparkles;
              return (
                <div
                  key={s.name}
                  className="yg-card yg-card-hover shrink-0 snap-start w-[168px] p-4 flex flex-col gap-3 min-h-[148px]"
                  data-testid={`service-card-m-${i}`}
                >
                  <div className="flex items-start justify-between">
                    <div className="w-9 h-9 rounded-[9px] flex items-center justify-center" style={{ background: "rgba(139,92,246,0.10)", border: "1px solid rgba(139,92,246,0.25)" }}>
                      <Icon className="w-4 h-4 text-[var(--yg-violet-light)]" strokeWidth={2} />
                    </div>
                    <span className="yg-mono text-[9px] tracking-[0.2em] uppercase text-[var(--yg-text-dim)]">{s.tag}</span>
                  </div>
                  <div className="flex-1">
                    <div className="text-white font-semibold text-[13.5px] leading-tight tracking-[-0.01em]">{s.name}</div>
                  </div>
                  <div className="yg-mono text-[10.5px] text-[var(--yg-violet-light)] tracking-tight">{s.metric}</div>
                </div>
              );
            })}
          </div>
          <div className="px-5 mt-1 flex items-center justify-between text-[10.5px] yg-mono uppercase tracking-[0.2em] text-[var(--yg-text-dim)]">
            <span>Swipe →</span>
            <span>21 services</span>
          </div>
        </div>

        <div className="hidden lg:grid grid-cols-4 xl:grid-cols-5 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = ICON_MAP[s.icon] || Sparkles;
            return (
              <div
                key={s.name}
                className="yg-card yg-card-hover p-5 flex flex-col gap-3 min-h-[148px]"
                data-testid={`service-card-${i}`}
                style={{ animation: `yg-rise 600ms ${(i % 5) * 60}ms both cubic-bezier(.2,.9,.3,1)` }}
              >
                <div className="flex items-start justify-between">
                  <div className="w-9 h-9 rounded-[9px] flex items-center justify-center" style={{ background: "rgba(139,92,246,0.10)", border: "1px solid rgba(139,92,246,0.25)" }}>
                    <Icon className="w-4 h-4 text-[var(--yg-violet-light)]" strokeWidth={2} />
                  </div>
                  <span className="yg-mono text-[9px] tracking-[0.22em] uppercase text-[var(--yg-text-dim)]">{s.tag}</span>
                </div>
                <div className="flex-1">
                  <div className="text-white font-semibold text-[14px] leading-tight tracking-[-0.01em]">{s.name}</div>
                </div>
                <div className="yg-mono text-[11px] text-[var(--yg-violet-light)] tracking-tight">{s.metric}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
